import * as Sentry from "@sentry/react"

const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content

if (dsn) {
  Sentry.init({
    dsn,
    environment: document.querySelector('meta[name="rails-env"]')?.content || "development",
    tracesSampleRate: parseFloat(document.querySelector('meta[name="sentry-traces-sample-rate"]')?.content) || 0.1,
  })
}

export default Sentry
